import { jsxs, jsx } from 'react/jsx-runtime';
import { CircularProgress } from '@material-ui/core';

var LoadingComponent = function (_a) {
        var caption = _a.caption;
        return jsxs("div", { style: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                }, children: [jsx(CircularProgress, {}), caption && jsx("div", { children: caption })] });
};

export { LoadingComponent as L };
